import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class EffluentSystemListenerService {
  readonly effluentSystemUpdated = new Subject<void>();
}
